module.exports = __webpack_public_path__ + "img/kwiecien_2016.a61ca6a2.jpg";